import { render } from "./caseIndex.vue?vue&type=template&id=653504c6"
import script from "./caseIndex.vue?vue&type=script&lang=js"
export * from "./caseIndex.vue?vue&type=script&lang=js"

import "./caseIndex.vue?vue&type=style&index=0&id=653504c6&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__